import { APP_BASE_HREF } from "@angular/common";

export const environment = {
  production: true,
  completeURL: 'https://is.simplelayers.com/',
	deployURL: 'https://is.simplelayers.com/',
  baseHref:'https://is.simplelayers.com/',
	serverURL:'https://ris-svcs.simplelayers.com/',
	mqGuid: 'me5vHyryLxRoPgkHskADP8AcixthCA0n',
  local:true,
  mapbox: {
		accessToken: 'pk.eyJ1Ijoic2ltcGxlbGF5ZXJzLWRldiIsImEiOiJjbGtyYzRwNnMybG42M2RwNGt1aG4zaWd1In0.BfNrvhVB568vILoDtLOTlQ'
	},
	envName: 'dev',
  unauthId:'john-q@public',
  s_id:'SESSIONID'
};
import 'zone.js/dist/zone-error';  // Included with Angular CLI.
